"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isText = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var REACT_FRAGMENT_TYPE = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null).type;
/**
 * Check whether a `children` prop is text — e.g. just a string (or interpolated string)
 */


var isText = function isText(children) {
  // If children is an object, it may be simple, just wrapped in a fragment(s)
  // `><>Example</><`
  if (!!children && _typeof(children) === "object" && "type" in children && children.type === REACT_FRAGMENT_TYPE) {
    return isText(children.props.children);
  } // Non-fragment interpolated children is an array:
  // `>Exmaple ({2 + 2})<` => ["Example (", 4, ")"]


  if (Array.isArray(children)) {
    return children.every(isText);
  }

  return typeof children === "string" || typeof children === "number";
};

exports.isText = isText;
//# sourceMappingURL=isText.js.map